<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pi"></a><a id="pii"></a><a id="piii"></a><a id="piv"></a>
<div class="copyright">
<p class="center ">Copyright 1941, 1939, 1938, 1937, 1936 by Eudora Welty<br/>
Copyright renewed 1968, 1967, 1966, 1965, 1964 by Eudora Welty</p>
<div class="timebreak "> </div>
<p class="center ">All rights reserved</p>
<div class="timebreak "> </div>
<p class="center ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="center "><a href="http://www.hmhco.com/popular-reading" target="_blank">hmhco.com</a></p>
<div class="timebreak "> </div>
<p class="center "><em>The Library of Congress has cataloged the print edition as follows:</em><br/>
Welty. Eudora, 1909–2001<br/>
A curtain of green, and other stories.<br/>
(A Harvest book)<br/>
I. Title.<br/>
PZ3W4696Cu 1979<br/>
[PS3545 E6] 813'.52 79-10389</p>
<div class="timebreak "> </div>
<p class="center "><span class="smallcaps">ISBN</span> 978-0-15-623492-4</p>
<div class="timebreak "> </div>
<p class="center indent3">For permission to reprint some of the stories in this collection the author wishes to thank the editors of the <em>Southern Review, Manuscript,</em> the <em>Prairie Schooner, Decision, New Directions, Harper’s Bazaar</em> and the <em>Atlantic Monthly</em>.</p>
<div class="timebreak "> </div>
<p class="center ">e<span class="smallcaps">ISBN</span> 978-0-547-53850-1</p>
<p class="center ">v5.0218</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?50179f42